import { Amplify } from 'aws-amplify';

/**
 * Amplify Auth (Cognito) is the ONLY AWS SDK surface in the frontend
 * (invariant I6) — everything else goes through the backend API.
 */
export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      },
    },
  });
}
